export const RoomsColors = {
  IKE: "#1F905C",
  STROUSTRUP: "#7986CB",
  GOSLING: "#FF9C40",
  GYM: "#D50000",
  ROSSUM: "#FCCB1B",
  ALL: "#DDDDDD",
};
